{
  "welcome": "환영합니다",
  "instructions": "아래를 탭하여 체크인을 시작하세요.",
  "startCheckIn": "체크인 시작",
  "missingWarehouseTitle": "창고 정보 누락",
  "missingWarehouseMessage": "링크가 잘못되었습니다. 창고 ID가 포함되어야 합니다",
  "recaptchaAttribution": "이 사이트는 reCAPTCHA로 보호되며 Google {privacyPolicy} 및 {termsOfService}이(가) 적용됩니다.",
  "recaptchaPrivacyPolicy": "개인정보처리방침",
  "recaptchaTermsOfService": "서비스 약관",
  "lookupTitle": "예약을 찾으려면 참조 번호 또는 확인 번호를 입력하세요",
  "referenceNumberLabel": "참조 번호 또는 확인 번호",
  "referenceNotFoundError": "참조 번호 또는 확인 번호와 일치하는 유효한 예약이 없습니다.",
  "checkIn": "체크인",
  "loadTypeLabel": "화물 유형",
  "directionLabel": "방향",
  "operationLabel": "작업",
  "dockLabel": "도크",
  "orDivider": "또는",
  "noReferenceTitle": "확인 번호가 없습니다",
  "noReferenceDescription": "표준 체크인 절차를 사용하여 예약 없이 진행합니다.",
  "checkInWithoutAppointment": "예약 없이 체크인",
  "readyToCheckInTitle": "체크인할 준비가 되셨나요?",
  "readyToCheckInDescription": "아래를 눌러 시작하세요. 다음 화면에서 정보를 입력합니다.",
  "referenceRequiredHint": "이 위치에서 체크인하려면 참조 번호가 필요합니다.",
  "haveAppointment": "예약이 있습니다",
  "direction": {
    "inbound": "입고",
    "outbound": "출고",
    "inOut": "입고 및 출고",
    "load": "상차",
    "unload": "하차"
  },
  "operation": {
    "live": "현장 상하차",
    "drop": "드롭(분리)",
    "other": "기타"
  }
}
